// src/features/auth/api/login.ts
import { api } from '@/shared/api/instance';
import type { LoginRequest, LoginResponse, LoginApiResponse } from './types';

export const login = async (data: LoginRequest): Promise<LoginResponse> => {
  // POST запрос на /api/v1/auth/login
  const response = await api.post<LoginApiResponse>('/api/v1/auth/login', data);

  // Transform snake_case API response to camelCase
  return {
    accessToken: response.data.data.access_token,
    refreshToken: response.data.data.refresh_token,
    expiredAt: response.data.data.expired_at,
  };
};
export const forgotPassword = async (data: {email:string}): Promise<any> => {
  const response = await api.post<any>('/api/v1/auth/forgot-password', data);

  return response.data;
};
